module.exports = {
  entry: './src/apps/ai-leadership-assistant/index.tsx',
  shortcode: 'ai-leadership-assistant',
  title: 'AI Leadership Assistant',
  status: 'stable',
  description: 'AI Leadership Assistant',
  preview: {
    url: `${process.env.PUBLIC_URL}/storybook/iframe.html?id=widgets-ai-leadership-assistant-components--default&viewMode=story`,
  },
  useExternalPeerDependencies: ['react', 'react-dom', 'react-intl'],
  additionalCustomProperties: {
    webSegmentPaths: ['/products', 'think', 'reports'],
    availableTranslations: ['en'],
  },
};
